import { Routes } from '@angular/router';

import { NotificationFeedComponent } from '@ninety/mobile/pages/notification-feed';
import { RoleName } from '@ninety/mobile/platform/api';
import {
  APP_ROUTES,
  AppReadyGuardFn,
  UserIsAnonymousGuardFn,
  UserIsAuthenticatedGuardFn,
  UserRoleIsVerifiedGuardFn,
  AllowAccessGuardFn,
  UserNotFreemiumGuardFn,
  QuarterlyDiscussionsGuardFn,
  MazEntitlementGuardFn,
  UserIsNotObserverGuardFn,
  UserIsObserverGuardFn,
} from '@ninety/mobile/platform/state';
import {
  AuthenticatedLayoutComponent,
  FreemiumComponent,
  NoAccessComponent,
  ObserverNoAccessComponent,
} from '@ninety/pages/layout';

const defaultRoute = `${APP_ROUTES.App}/${APP_ROUTES.Home}`;

const {
  App,
  Home,
  Settings,
  Login,
  Offline,
  People,
  Discussions,
  Assessments,
  Directory,
  Todos,
  Issues,
  Rocks,
  NoAccess,
  Observer,
  Headlines,
  NotificationsFeed,
  Freemium,
  Maz,
  DelegateElevate,
  Scorecard,
} = APP_ROUTES;

export const appRoutes: Routes = [
  {
    path: Login,
    canActivate: [UserIsAnonymousGuardFn],
    loadChildren: () => import('@ninety/mobile/pages/login-page').then(m => m.mobileLoginPageRoutes),
  },
  {
    path: Offline,
    loadComponent: () => import('./offline/offline.page').then(m => m.OfflinePage),
  },
  {
    path: '',
    redirectTo: defaultRoute,
    pathMatch: 'full',
  },
  {
    path: NoAccess,
    canActivate: [UserIsAuthenticatedGuardFn, AppReadyGuardFn],
    children: [
      { path: '', component: NoAccessComponent },
      { path: Observer, canActivate: [UserIsObserverGuardFn], component: ObserverNoAccessComponent },
    ],
  },
  {
    path: Freemium,
    canActivate: [UserIsAuthenticatedGuardFn, AppReadyGuardFn],
    component: FreemiumComponent,
  },
  {
    path: App,
    component: AuthenticatedLayoutComponent,
    canActivate: [UserIsAuthenticatedGuardFn, AppReadyGuardFn, AllowAccessGuardFn],
    canActivateChild: [UserIsAuthenticatedGuardFn, UserIsNotObserverGuardFn, UserNotFreemiumGuardFn],
    children: [
      {
        path: Home,
        loadChildren: () => import('@ninety/mobile/pages/home-page').then(m => m.mobileHomePageRoutes),
      },
      {
        path: Maz,
        canActivate: [MazEntitlementGuardFn],
        loadChildren: () => import('@ninety/maz').then(m => m.mobileMazRoutes),
      },
      {
        path: Settings,
        loadChildren: () => import('@ninety/mobile/pages/settings-page').then(m => m.mobileSettingsPageRoutes),
      },
      {
        path: Todos,
        loadChildren: () => import('@ninety/mobile/pages/to-dos-page').then(m => m.mobileToDosPageRoutes),
      },
      {
        path: Issues,
        loadChildren: () => import('@ninety/mobile/pages/issues-page').then(m => m.mobileIssuesPageRoutes),
      },
      {
        path: Rocks,
        loadChildren: () => import('@ninety/mobile/pages/rocks').then(m => m.rocksRoutes),
      },
      {
        path: `${People}/${Discussions}`,
        canActivate: [QuarterlyDiscussionsGuardFn],
        canActivateChild: [UserRoleIsVerifiedGuardFn],
        data: { checkMinRole: RoleName.managee },
        loadChildren: () => import('@ninety/mobile/pages/discussions-page').then(m => m.mobileDiscussionsPageRoutes),
      },
      {
        path: `${People}/${Assessments}`,
        loadChildren: () => import('@ninety/mobile/pages/assessments-page').then(m => m.mobileAssessmentsPageRoutes),
      },
      {
        path: `${People}/${DelegateElevate}`,
        loadChildren: () =>
          import('@ninety/mobile/pages/delegate-elevate-page').then(m => m.mobileDelegateElevatePageRoutes),
      },
      {
        path: `${People}`,
        redirectTo: `${People}/${Discussions}`,
      },
      {
        path: Directory,
        loadChildren: () => import('@ninety/mobile/pages/directory-page').then(m => m.mobileDirectoryPageRoutes),
      },
      {
        path: Headlines,
        loadChildren: () => import('@ninety/mobile/pages/headlines-page').then(m => m.mobileHeadlinesPageRoutes),
      },
      {
        path: Scorecard,
        loadChildren: () => import('@ninety/mobile/pages/scorecard-page').then(m => m.mobileScorecardPageRoutes),
      },
      {
        path: NotificationsFeed,
        component: NotificationFeedComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: defaultRoute,
    pathMatch: 'full',
  },
];
